import publicSansRegular from "../assets/Public_Sans/PublicSans-Regular.ttf";
import publicSansBold from "../assets/Public_Sans/PublicSans-Bold.ttf";
import publicSansItalic from "../assets/Public_Sans/PublicSans-Italic.ttf";

// Public Sans is the family every TriloDocs app renders in (see scss/fonts.scss),
// so the PDF exports embed it as well. The variable font the stylesheets use
// can't be embedded as-is: @react-pdf keeps whatever instance a font file
// defaults to, and Public Sans defaults to Thin (wght 100), so these are static
// Regular/Bold/Italic cuts of the same family.
export const PDF_FONT_FAMILY = "Public Sans";

// One of PDF's base-14 fonts, always available to a viewer without embedding -
// a font that fails to load should not take the whole export down with it.
export const PDF_FALLBACK_FONT_FAMILY = "Helvetica";

// @react-pdf resolves sources through `is-url`, which rejects the root-relative
// paths the bundler emits, so the asset URLs have to be made absolute first.
const assetUrl = path => new URL(path, window.location.href).href;

let isRegistered = false;

// Returns the family to style a PDF with: "Public Sans" once its files are in
// the font store, or "Helvetica" if they could not be fetched or parsed.
// Waiting on the loads here - rather than letting the renderer fetch them - is
// what makes that fallback possible, since pdf() throws mid-render otherwise.
export const ensurePdfFont = async () => {
  try {
    const { Font } = await import("@react-pdf/renderer");
    if (!isRegistered) {
      Font.register({
        family: PDF_FONT_FAMILY,
        fonts: [
          { src: assetUrl(publicSansRegular), fontWeight: "normal" },
          { src: assetUrl(publicSansBold), fontWeight: "bold" },
          { src: assetUrl(publicSansItalic), fontStyle: "italic" },
        ],
      });
      isRegistered = true;
    }
    await Promise.all([
      Font.load({ fontFamily: PDF_FONT_FAMILY, fontWeight: 400 }),
      Font.load({ fontFamily: PDF_FONT_FAMILY, fontWeight: 700 }),
      Font.load({ fontFamily: PDF_FONT_FAMILY, fontStyle: "italic" }),
    ]);
    return PDF_FONT_FAMILY;
  } catch (error) {
    console.warn(
      `${PDF_FONT_FAMILY} could not be embedded in the PDF, falling back to ${PDF_FALLBACK_FONT_FAMILY}`,
      error
    );
    return PDF_FALLBACK_FONT_FAMILY;
  }
};
